<template>
  <info-field class="pa-4">
    <i18n path="message.welcome.greetings">
      <template v-slot:br>
        <br />
      </template>
      <template v-slot:contactDetails>
        <b>{{ $t('message.welcome.contactDetails') }}</b>
      </template>
      <template v-slot:organizationalMatters>
        <b>{{ $t('message.welcome.organizationalMatters') }}</b>
      </template>
      <template v-slot:dueDate>
        <b>{{ $t('message.welcome.by') }} {{ dateFilter(dueDate) }}</b>
      </template>
      <template v-slot:startDate v-if="filteredStartDate">
        {{ $t('message.welcome.on') }} {{ filteredStartDate }}</template
      >
    </i18n>
  </info-field>
</template>

<script>
import { formatDate } from '@/helpers/intl';
import InfoField from '@/components/fields/InfoField.vue';
import { mapGetters } from 'vuex';

export default {
  methods: {
    dateFilter(value, nullable = false) {
      if (!value) {
        return nullable ? '' : `[${this.$t('common.dateNotFilled')}]`;
      }

      return formatDate(value);
    },
  },
  computed: {
    ...mapGetters('candidate', ['startDate', 'dueDate']),
    filteredStartDate() {
      return this.dateFilter(this.startDate, true);
    },
  },
  components: { InfoField },
};
</script>
